module.exports = __webpack_public_path__ + "img/itstatement.d2ae20db.svg";